import { Quote } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const PersonCard = ({ photo, name, role, quote, testid, delay = 0 }) => (
  <Reveal delay={delay} className="h-full">
    <div className="flex flex-col h-full" data-testid={testid}>
      <div className="relative">
        <div className="absolute -inset-2 border border-cherry/50 rounded-2xl translate-x-3 translate-y-3" />
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src={photo}
            alt={name}
            data-testid={`${testid}-photo`}
            className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-700 ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/10 to-transparent" />
          <div className="absolute bottom-0 inset-x-0 p-5">
            <p className="font-serif text-xl sm:text-2xl font-semibold text-white" data-testid={`${testid}-name`}>{name}</p>
            <p className="text-[11px] font-mono uppercase tracking-widest text-sky mt-1" data-testid={`${testid}-role`}>{role}</p>
          </div>
        </div>
      </div>
      <div className="mt-7 flex gap-4">
        <Quote className="h-7 w-7 text-cherry shrink-0 mt-1" fill="currentColor" />
        <p className="font-serif italic text-lg sm:text-xl text-white/85 leading-snug" data-testid={`${testid}-quote`}>
          {quote}
        </p>
      </div>
    </div>
  </Reveal>
);

export default function Founder({ content }) {
  return (
    <section id="founder" data-testid="founder-section" className="relative bg-navy py-20 sm:py-28 lg:py-36 overflow-hidden">
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-cherry/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-sky/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <Overline light>{content.founder_overline}</Overline>
          <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.1]" data-testid="founder-title">
            {content.founder_title}
          </h2>
          <p className="mt-6 text-base sm:text-lg font-sans text-white/65 leading-relaxed" data-testid="founder-story">
            {content.founder_story}
          </p>
        </Reveal>

        <div className="mt-14 sm:mt-16 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-10 lg:gap-16 max-w-5xl">
          <PersonCard
            testid="founder-card"
            photo={content.founder_photo}
            name={content.founder_name}
            role={content.founder_role}
            quote={content.founder_quote}
            delay={0.1}
          />
          <PersonCard
            testid="cofounder-card"
            photo={content.co_founder_photo || "https://images.unsplash.com/photo-1535905557558-afc4877a26fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NxA1NxB0fDB8MXxzZWFyY2h8M3x8YWNhZGVtaWMlMjBsaWJyYXJ5JTIwYm9va3MlMjBzdHVkeXxlbnwwfHx8fDE3OTE1MzEwNzZ8MA&ixlib=rb-4.1.0&q=85"}
            name={content.co_founder_name || "Co-Founder"}
            role={content.co_founder_role || "Co-Founder & Research Mentor"}
            quote={content.co_founder_quote || "Add the co-founder's vision and motivation here from the Admin panel."}
            delay={0.25}
          />
        </div>
      </div>
    </section>
  );
}
